import React from "react";
import {
  Card,
  CardContent,
  Typography,
  Grid,
  Select,
  MenuItem,
  TextField,
  FormHelperText,
  FormControl,
  InputAdornment,
  Chip,
  Box,
  OutlinedInput,
  InputLabel,
  Checkbox
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";

const FormCard = ({ title, fields }) => {
  return (
    <Card>
      <CardContent>
        <Typography variant="h6" fontWeight={600} mb={2}>
          {title?.toUpperCase()}
        </Typography>
        <Grid container spacing={1}>
          {fields.map((field, index) => (
            <Grid item xs={12} md={field.fullWidth ? 12 : 6} key={index}>
              {field.type === "select" ? (
                <FormControl
                  fullWidth
                  size="small"
                  required
                >
                  <Select
                    variant="outlined"
                    displayEmpty
                    value={field.value || ""}
                    onChange={(e) => field.onChange?.(e.target.value)}
                  >
                    {field.options.map((option, i) => (
                      <MenuItem key={i} value={option.id}>
                        {option.value}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              ) :
                field.multiSelect ? (
                  <FormControl fullWidth size="small">
                    <InputLabel id="multi-select-label">{field.placeholder}</InputLabel>
                    <Select
                      labelId="multi-select-label"
                      multiple
                      displayEmpty
                      value={field.value || []}
                      onChange={(e) => {
                        const value = e.target.value;
                        const allValues = field.options.map((opt) => opt.id);
                        if (value.includes("all")) {
                          const isAllSelected = field.value.length === field.options.length;
                          field.onChange?.(isAllSelected ? [] : allValues);
                        } else {
                          field.onChange?.(value);
                        }
                      }}
                      input={<OutlinedInput label={field.placeholder} />}
                      renderValue={(selected) =>
                        selected.length ? (
                          <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                            {selected?.map((value) => (
                              <Chip
                                key={value}
                                label={field.options.find((opt) => opt.id === value)?.value}
                              />
                            ))}
                          </Box>
                        ) : (
                          <></>
                        )
                      }
                    >
                      <MenuItem value="all">
                        <Checkbox
                          indeterminate={
                            field.value.length > 0 &&
                            field.value.length < field.options.length
                          }
                          checked={field.value.length === field.options.length}
                        />
                        Select All
                      </MenuItem>
                      {field.options?.map((option, i) => (
                        <MenuItem key={i} value={option.id}>
                          <Checkbox checked={field.value.includes(option?.id)} />
                          {option.value}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                ) : (
                  <TextField
                    fullWidth
                    size="small"
                    variant="outlined"
                    label={field.placeholder}
                    type={field.type || "text"}
                    placeholder={field.placeholder}
                    required={field.required}
                    InputProps={{
                      startAdornment:
                        field.name === "search" ? (
                          <InputAdornment position="start">
                            <SearchIcon />
                          </InputAdornment>
                        ) : null,
                    }}
                    onChange={(e) => field.onChange?.(e.target.value)}
                    value={field.value || ""}
                    disabled={field?.isDisabled || false}
                  />
                )}
            </Grid>
          ))}
        </Grid>
      </CardContent>
    </Card>
  );
};

export default FormCard;
